import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { TaskTimerHistory } from '../../../data-services/task-timer/task-timer.model';

export const postTaskTimerHistory = createAction(
    '[TaskTimerHistory/API] POST TaskTimerHistory',
    props<{ StartDate: string, EndDate: string }>()
);

export const putTaskTimerHistory = createAction(
    '[TaskTimerHistory/API] PUT TaskTimerHistory',
    props<{ JsonString: any }>()
);

export const loadTaskTimerHistorys = createAction(
    '[TaskTimerHistory/API] Load TaskTimerHistorys',
    props<{ TaskTimerHistorys: any[] }>()
);

export const addTaskTimerHistory = createAction(
    '[TaskTimerHistory/API] Add TaskTimerHistory',
    props<{ TaskTimerHistory: TaskTimerHistory }>()
);

export const upsertTaskTimerHistory = createAction(
    '[TaskTimerHistory/API] Upsert TaskTimerHistory',
    props<{ TaskTimerHistory: TaskTimerHistory }>()
);

export const addTaskTimerHistorys = createAction(
    '[TaskTimerHistory/API] Add TaskTimerHistorys',
    props<{ TaskTimerHistorys: TaskTimerHistory[] }>()
);

export const upsertTaskTimerHistorys = createAction(
    '[TaskTimerHistory/API] Upsert TaskTimerHistorys',
    props<{ TaskTimerHistorys: TaskTimerHistory[] }>()
);

export const updateTaskTimerHistory = createAction(
    '[TaskTimerHistory/API] Update TaskTimerHistory',
    props<{ TaskTimerHistory: Update<TaskTimerHistory> }>()
);

export const updateTaskTimerHistorys = createAction(
    '[TaskTimerHistory/API] Update TaskTimerHistorys',
    props<{ TaskTimerHistorys: Update<TaskTimerHistory>[] }>()
);

export const deleteTaskTimerHistory = createAction(
    '[TaskTimerHistory/API] Delete TaskTimerHistory',
    props<{ id: string }>()
);

export const deleteTaskTimerHistorys = createAction(
    '[TaskTimerHistory/API] Delete TaskTimerHistorys',
    props<{ ids: string[] }>()
);

export const clearTaskTimerHistorys = createAction(
    '[TaskTimerHistory/API] Clear TaskTimerHistorys'
);
